// The Workflow board's "what can I see" tick boxes (firm, 2026-10-30: "tick
// boxes for what you can see: All, Bookkeeping, Year ends, T1's, Other").
// "All" is not a category -- it is every box ticked at once.

import { isBookkeepingTask } from "../tasks/bookkeeping";

export const WORKFLOW_CATEGORIES = [
  { key: "bookkeeping", label: "Bookkeeping" },
  { key: "corporate", label: "Year ends" },
  { key: "personal", label: "T1's" },
  { key: "other", label: "Other" },
];

export const CATEGORY_KEYS = WORKFLOW_CATEGORIES.map((c) => c.key);

// Which box a card answers to. Bookkeeping is an Other task whose type names
// bookkeeping -- the same rule as the Tasks page's Bookkeeping tab. "Other" is
// every remaining kind of work, T-slips included: the firm's list has no box
// for them, and a card nobody can tick into view is a card lost.
export function categoryOf(card) {
  if (card.kind === "other-task" || card.is_other_task) {
    return isBookkeepingTask(card) ? "bookkeeping" : "other";
  }
  if (card.task_type === "corporate") return "corporate";
  if (card.task_type === "personal") return "personal";
  return "other";
}
